'use strict';

angular.module('far.admin')
	.controller('MountainsIndexController', function ($window, mountains, softdeleteable) {
        (function init() {
            softdeleteable.setModel(mountains);
        })();

		var vm = {
            isDelete: function(id) {
                return softdeleteable.check(id);
            },
			delete: function(id) {
                softdeleteable.delete(id);
			},
            restore: function(id) {
                softdeleteable.restore(id);
            },
            update: function () {
                var data = {};
                
                if (!isNaN(parseInt(vm.mountain_region))) {
                    data.mountain_region = vm.mountain_region;
                }
                
                if (!isNaN(parseInt(vm.mountain_area))) {
                    data.mountain_area = vm.mountain_area;
                }
                
                $window.location.href = Routing.generate('admin_mountains', data)
            }
		};

		return vm;
	});
